<template>
    <AppHeaderDropdown right no-caret show>
        <template slot="header">
            <b-nav-item class="d-md-down-none">
                <i class="icon-screen-desktop" style="color: #fff;"></i>
            </b-nav-item>
        </template>
        <template slot="dropdown">
            <b-dropdown-text>Laden Sie das Web-Auftragsbuch herunter, dies legt eine Verknüpfung auf Ihrem Desktop ab und ermöglicht Ihnen einen automatische Anmeldung.</b-dropdown-text>
            <b-dropdown-item v-on:click="trigger"><i class="fa fa-download" />Herunterladen</b-dropdown-item>
            <a href="https://bisoffice.app/install/latest/BisofficeSetup.exe" ref="link" title="Herunterladen" download="BisofficeSetup.exe" style="display: none">Herunterladen</a>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
    export default {
        name: 'DownloadWindowsDropdown',
        components: {
            AppHeaderDropdown
        },
        props:{
            username: {
                type: String,
                default: "Einstellungen"
            }
        },
        methods: {
            trigger() {
                this.$refs.link.click();
            }
        }
    }
</script>
